import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function TecnoCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            <span className="purple">TecnoCraft/ZeroRoleplay</span>{" "}
            è uno dei server Minecraft italiani{" "}<span className="purple">più famosi e longevi{" "}</span>
            dedicati alla modalità{" "}
            <span className="purple">Roleplay</span>.
            <br />
            <br />
            L'esperienza si snoda attraverso tre macro-aree distinte: la vibrante metropoli di{" "}
            <span className="purple">NeoTecno{" "}</span>
            (cuore pulsante ispirato all'urbanistica italiana), l'esclusivo distretto del lusso di{" "}
            <span className="purple">Victoria{" "}</span>ed lo{" "}
            <span className="purple">Stato Vaticano</span>.
            <br />
            <br />
            <span className="joystick" role="img" aria-label="joystick">
              🎮
            </span>
            {" "} Accessibile all'IP: <span className="purple">mc.zeroroleplay.it</span>
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default TecnoCard;
